import { TranslationKeys } from 'locales/translationKeys'

export type FeedingType =
  | 'frozen-raw'
  | 'freeze-dried-raw'
  | 'wet-food'
  | 'cooked-food'
  | 'air-dried-food'
  | 'kibble'
  | 'other'

export const FEEDING_TYPES: FeedingType[] = [
  'frozen-raw',
  'freeze-dried-raw',
  'wet-food',
  'cooked-food',
  'air-dried-food',
  'kibble',
  'other',
]

export type FeedingInfoContent = {
  badge: string
  headline: string
  description: string
}

export const FEEDING_COMPARISON_CTA_URL = '/meal-plan'

type TFunction = (key: TranslationKeys) => string

// FEEDING_TYPES entries are the only valid values interpolated here, so this always
// produces a key that exists in the generated `blog.json` translation tree.
const feedingKey = (type: FeedingType, leaf: string) =>
  `blog:currently-feeding.info.${type}.${leaf}` as TranslationKeys

export const getPillLabel = (t: TFunction, type: FeedingType): string =>
  t(`blog:currently-feeding.pills.${type}` as TranslationKeys)

export const getFeedingInfo = (t: TFunction, type: FeedingType): FeedingInfoContent => ({
  badge: t(feedingKey(type, 'badge')),
  headline: t(feedingKey(type, 'headline')),
  description: t(feedingKey(type, 'description')),
})
